/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS103: Rewrite code to no longer use __guard__
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import toastr from '@/lib/notifications';
import $ from 'jquery';
import _ from 'underscore';
import store from '../state/store';

store.on('enquiry:learners:index', function(enquiry_id) {
  const params =
    {enquiry_id};

  return $.ajax({
    url: "/api/sales/enquiry_learners",
    type: 'GET',
    dataType: 'json',
    contentType: 'application/json',
    data: params,
    success: (data) => {
      return store.get().enquiry.set({learners: data.items});
    },
    error: (data) => {
      return toastr.error(__guard__(data != null ? data.responseJSON : undefined, x => x.custom_error_message) || 'something went wrong');
    }
  });
});

store.on('enquiry:learners:create', function(enquiry_id, learner_name) {
  const params = {
    enquiry_id,
    learner_name
  };

  return $.ajax({
    url: "/api/sales/enquiry_learners",
    type: 'POST',
    dataType: 'json',
    contentType: 'application/json',
    data: JSON.stringify(params),
    success: (data) => {
      return store.get().enquiry.learners.push(data);
    },
    error: (data) => {
      return toastr.error(__guard__(data != null ? data.responseJSON : undefined, x => x.custom_error_message) || 'something went wrong');
    }
  });
});

store.on('enquiry:learners:update', function(enquiry_id, learner_id, update_params) {
  if (update_params == null) { update_params = {}; }
  const request_params = _.extend(update_params,
    {learner_id});

  return $.ajax({
    url: `/api/sales/enquiry_learners/${learner_id}`,
    type: 'PUT',
    dataType: 'json',
    contentType: 'application/json',
    data: JSON.stringify(request_params),
    success: (data) => {
      const el = _.first(_.select(store.get().enquiry.learners, learner => learner.id ===data.id));
      return el.set(data);
    },
    error: (data) => {
      return toastr.error(__guard__(data != null ? data.responseJSON : undefined, x => x.custom_error_message) || 'something went wrong');
    }
  });
});

store.on('enquiry:learners:create_learner', function(learner_id) {
  return $.ajax({
    url: `/api/sales/enquiry_learners/${learner_id}/create_learner`,
    type: 'PUT',
    dataType: 'json',
    contentType: 'application/json',
    success: (data) => {
      const el = _.first(_.select(store.get().enquiry.learners, learner => learner.id === data.id));
      if (el) { el.set(data); }
      return toastr.success('Learner added to customer profile.');
    },
    error: (data) => {
      return toastr.error(__guard__(data != null ? data.responseJSON : undefined, x => x.custom_error_message) || 'something went wrong');
    }
  });
});

store.on('enquiry:learners:link_to_customer_learner', function(enquiry_learner_id, customer_learner_id) {
  return $.ajax({
    url: `/api/sales/enquiry_learners/${enquiry_learner_id}/link_to_customer_learner`,
    type: 'PUT',
    dataType: 'json',
    contentType: 'application/json',
    data: JSON.stringify({learner_id: customer_learner_id}),
    success: (data) => {
      const el = _.first(_.select(store.get().enquiry.learners, learner => learner.id === data.id));
      if (el) { el.set(data); }
      return toastr.success('Linked to existing customer learner.');
    },
    error: (data) => {
      return toastr.error(__guard__(data != null ? data.responseJSON : undefined, x => x.custom_error_message) || 'something went wrong');
    }
  });
});

store.on('enquiry:learners:destroy', function(enquiry_id, learner_id) {
  $.ajax({
    url: `/api/sales/enquiry_learners/${learner_id}`,
    type: 'DELETE',
    dataType: 'json',
    contentType: 'application/json',
    success: (data) => {
      store.emit('enquiry:learners:index', enquiry_id);
      return store.emit('enquiry:learner_subjects:index', enquiry_id);
    },
    error: (data) => {
      return toastr.error(__guard__(data != null ? data.responseJSON : undefined, x => x.custom_error_message) || 'something went wrong');
    }
  })
});

function __guard__(value, transform) {
  return (typeof value !== 'undefined' && value !== null) ? transform(value) : undefined;
}